import { lazy, useEffect } from "react";
import { Outlet, Route } from "react-router";
import LayoutCart from "../../features/Cart/shared/layout.tsx";
import EmptyCart from "../../features/Cart/Cart/EmptyCart.tsx";

import { fetchProducts, setLoading } from "../../stores/cart/cartSlice.ts";
import { useAppDispatch, useAppSelector } from "../../services/hooks.ts";
import PageTitle from "../../helpers/PageTitle.tsx";

const Cart = lazy(() => import('../../features/Cart/Cart/Cart.tsx'));
const CartFinalize = lazy(() => import('../../features/Cart/Cart/CartFinalize.tsx'));
const Checkout = lazy(() => import('../../features/Cart/Checkout/Checkout.tsx'));
const Summary = lazy(() => import('../../features/Cart/Summary/Summary.tsx'));

function IsCartEmpty() {
    const dispatch = useAppDispatch();
    const products = useAppSelector((state) => state.cart.products);

    useEffect(() => {
        dispatch(setLoading(true))
        dispatch(fetchProducts())
    }, [])

    if (Array.isArray(products) && products.length > 0) {
        return <Outlet />;
    }

    return <EmptyCart />;
}

const CartRoute = (<>
    <Route path="cart/thanks" handle={{ breadcrumb: "cart.thanks" }} element={<PageTitle title={["cart.thanks", "main"]}><CartFinalize /></PageTitle>} />
    <Route path="cart/summary" handle={{ breadcrumb: "cart.summary" }} element={<PageTitle title={["cart.summary", "cart.summary", "main"]}><LayoutCart /></PageTitle>} >
        {/* TODO Route do poprawy (okruszek) */}
        <Route path=":hash" handle={{ breadcrumb: ({ params }: any) => `${params.hash}` }} element={<Summary />} />
    </Route>
    <Route
        path="cart"
        handle={{ breadcrumb: "cart.main" }}
        element={<PageTitle title={["cart.main", "main"]}><IsCartEmpty /></PageTitle>}
    >
        <Route element={<LayoutCart />}>
            <Route index element={<Cart />} />
            <Route path="checkout" handle={{ breadcrumb: "cart.checkout" }} element={<PageTitle title={["cart.checkout", "cart.main", "main"]}><Checkout /></PageTitle>} />
            <Route path="*" element={<EmptyCart />} />
        </Route>
    </Route>
</>)

export default CartRoute;

//+przzjście z 1 na 2
//+niezalogowany pokazuje modal
//+po odpowiedzi success przechodzi na 2 strone koszyka
//+zalogowany przechodzi dalej
//+przejście z 2 na 3
//+niezalogowany przekierowuje na 1 strone
//+zalogowany wysyła request o zamówieniu
//+checkboxy muszą być zaznaczone
//+ładuje metody płatności metody dostawy
//+ czy ładuje wszystkie dane